import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedStatus:[],
  selectedSharedUid: null,
  selectedSite: null,
  ETLProcessListData: [],
  selectedRows: [],
  page: 0,
  rowsPerPage: 10,
  selectedETLProcessList: null,
};

const ETLProcessListSlice = createSlice({
  name: "ETLProcessList",
  initialState: initialState,
  reducers: {
    setSelectedStatus: (state, action) => {
      state.selectedStatus = action.payload;
    },
    setSelectedSite: (state, action) => {
      state.selectedSite = action.payload;
    },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
    setSelectedSharedUid: (state, action) => {
      state.selectedSharedUid = action.payload;
    },
    setETLProcessListData: (state, action) => {
      state.ETLProcessListData = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSelectedETLProcessList: (state, action) => {
      state.selectedETLProcessList = action.payload;
    },
  },
});

export const {
  setSelectedStatus,
  setSelectedSharedUid,
  setSelectedSite,
  setETLProcessListData,
  setPage,
  setSelectedETLProcessList,
  setRowsPerPage,
  setSelectedRows
} = ETLProcessListSlice.actions;
export default ETLProcessListSlice.reducer;
